//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 21.09.2016.
 */


(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTableColumnDurationFilter', srsngTableColumnDurationFilter);

    function srsngTableColumnDurationFilter() {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/mega-table/filter/duration/duration.html',
            scope: {
                data: '='
            },
            controller: controller,
            link: link
        };

        function controller($scope) {

            $scope.parse = duration => {

                setDuration(duration, ((duration.hours || 0) * 3600 + (duration.minutes || 0) * 60 + (duration.seconds || 0)) * 1000);
                $scope.filter();
            };

            $scope.step = (duration, step) => {

                setDuration(duration, (duration.milliseconds || 0) + step);
                $scope.filter();
            };

            $scope.sort = direction => {

                $scope.filter();
            };

            $scope.search = () => {

                $scope.filter();
            };

            $scope.filter = () => {
                $scope.data.callback($scope.data);
            };

            $scope.reset = () => {

                setDuration($scope.data.fromDuration, null);
                setDuration($scope.data.toDuration, null);
                $scope.data.ipAddressFilterType = 'none';
                $scope.filter();
            };

            $scope.updateFilterType = () => {

                $scope.filter();
            };

            init();

            function init() {

                if ($scope.data.searchText == null)
                    $scope.data.searchText = '';

                if ($scope.data.durationFilterType == null)
                    $scope.data.durationFilterType = 'none';

                if ($scope.data.fromDuration == null) {

                    $scope.data.fromDuration = {
                        name: 'from',
                        label: 'From'
                    };

                    setDuration($scope.data.fromDuration, null);
                }

                if ($scope.data.toDuration == null) {

                    $scope.data.toDuration = {
                        name: 'to',
                        label: 'To'
                    };

                    setDuration($scope.data.toDuration, null);
                }
            }

            function setDuration(duration, milliseconds) {

                if (milliseconds < 0) milliseconds = 0;

                duration.milliseconds = milliseconds;

                if (milliseconds == null) {

                    duration.hours = duration.minutes = duration.seconds = null;

                } else {

                    duration.hours = Math.floor(milliseconds / 1000 / 3600);
                    duration.minutes = Math.floor(milliseconds / 1000 % 3600 / 60);
                    duration.seconds = Math.floor(milliseconds / 1000 % 3600 % 60);
                }
            }
        }

        function link(scope, element, attrs) {

            element.on('$destroy', function () {
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });
        }
    }
})();
